import styled from 'styled-components'

import { COLOR, NATIVE_BASE_COLORS, FONT_SIZE } from '../../../../themes'
import { colorThemeSelector } from '../../../../helpers'

export const StylesRepeatOn = styled.div`
  width: 100%;
  height: auto;
  margin-top: 32px;

  .title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .week-layout {
    display: flex;
    margin-top: 16px;
  }

  .option-circle {
    width: 32px;
    height: 32px;
    border-radius: 100px;
    background-color: ${NATIVE_BASE_COLORS.TEXT[200]};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background-color: ${COLOR.HOVER_REPEAT_BOOKING};
    }
  }

  .option-highlighted-circle {
    width: 32px;
    height: 32px;
    border-radius: 100px;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background-color: ${COLOR.HOVER_REPEAT_BOOKING};
    }
  }

  .option-circle-text {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[600]};
    cursor: pointer;
  }

  .option-highlighted-circle-text {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    cursor: pointer;
  }

  .selected-option {
    width: fit-content;
    height: 44px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    padding: 0px 10px;
    background-color: ${NATIVE_BASE_COLORS.TEXT[200]};
    border: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};
    border-radius: 4px;
    cursor: pointer;
  }

  .selected-active-option {
    width: fit-content;
    height: 44px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    padding: 0px 10px;
    background-color: ${COLOR.BG_ACTIVE_DROPDOWN_REPEAT_BOOKING};
    border: 1px solid ${NATIVE_BASE_COLORS.PRIMARY[200]};
    border-radius: 4px;
    cursor: pointer;
  }

  .option-text {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    margin-right: 10px;
    cursor: pointer;
  }

  .nunito-semibold {
    font-family: NunitoSansSemibold;
  }

  .monthly-layout {
    position: relative;
  }

  .monthly-options {
    position: absolute;
    top: 48;
    left: 0;
    z-index: 2;
    width: auto;
    height: auto;
    background-color: ${COLOR.WHITE};
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.40);
  }

  .arrow-down {
    rotate: 180deg;
  }
`
